import { Component, HostListener, Input, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UtilService } from 'src/app/shared/util.service';
import { DataViewService } from '../edit-dataview/dataview.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';
import { formatDate } from '@angular/common';
@Component({
  selector: 'admin-settings',
  templateUrl: './admin-settings.component.html',
  styleUrls: ['./admin-settings.component.scss']
})
export class AdminSettingsComponent implements OnInit {
  AGTableHeaders: any[] = ['Access Group Name', 'Dataviews Assigned', 'Actions']
  DVTableHeaders: any[] = ['View Name', 'Assigned Access Groups','Created On', 'Last Refreshed', 'Actions']
  dataviews: any[] = []
  dataviews2: any[] = [{ name: 'test' }, { name: 'test' }, { name: 'test' }, { name: 'test' }, { name: 'test' }, { name: 'test' }]
  viewIdToBeDeleted: any;
  viewIdToBeDeletedAG: any;
  errorMessageSubmit: any;
  successMessage: string;
  pageSize = 10;
  p = 1;
  totalViews: any = [];
  totalViewsAG: any = [];
  searchTerm: any = '';
  AGTableData: any = [];
  otherListOptionFlag = false;
  optionActiveId: any = null;
  searchText: any = '';
  userId: any = null;
  sortBy = 'created_date';
  sortByForView = 'refresh_date';
  sortType = 'desc';
  page = 1;
  limit = 10;
  isAscending = false
  activeSortIndex: any = null
  @Input() isManageDV = false
  @Input() isManageAG = true
  @Input() showEditAGpopup = false
  @Input() showCreateAGpopup = false
  @Input() showDeletepopup = false
  showConfirmPopup=false;
  accesGroupForm: FormGroup;
  currentPage = 1;
  itemsPerPage: number = 10
  headerText = signal('');
  listOfViews:any=null
  dataViewCount=0
  assignedView:any=null;
  showOthersPopup=false;
  existingGroupNames:any=[];
  currentEditingItem:any=null;
  listOfAllViews:any=null
  searchTxt=''
  cancelFlag=false;
  searchControl = new FormControl(''); 
  errText:string=null;
  viewNameToBeDeleted: any = '';
  updatedDVTableHeaders: Array<{ id: number, column_name: string } | any > = [
    {
      id: 5,
      column_name: 'Dataview name'
    },
    {
      id: 6,
      column_name: 'Type'
    },
     {
      id: 6,
      column_name: 'Update Available'
    },
    {
      id: 7,
      column_name: 'Created On'
    },
    {
      id: 8,
      column_name: 'Last Modified'
    },
    {
      id: 9,
      column_name: 'Last Refreshed'
    }
  ]

  accessGroups: any[] = []
  
  updatedDVs: any[] = []
  @Input() showRefreshpopup = false
  selectAllUpdatedDVs: boolean = false;
  selectedDataviews: any[]=[];
  totalRefreshViews: any;
  maxDate: Date = new Date();
  createdRange = new FormGroup({
    startDate: new FormControl<Date | null>(null),
    endDate: new FormControl<Date | null>(null),
  });
  updatedRange = new FormGroup({
    startDate: new FormControl<Date | null>(null),
    endDate: new FormControl<Date | null>(null),
  });
  dateType: any = 'created';
  constructor(private router: Router, private dataViewService: DataViewService, private spinner: NgxSpinnerService, private utilService: UtilService, private fb: FormBuilder) { }
  ngOnInit() {
    this.setCreatedDateValidation();
    this.setUpdatedDateValidation();
    this.spinner.show();
    this.utilService.managedView.subscribe(res => {
       if(res){
         this.isManageDV = true;
         this.isManageAG= false;
       } else {
        this.isManageDV = false;
        this.isManageAG= true;
       }
    })
    this.dataViewService.getAllViews('', this.sortByForView, this.sortType, this.pageSize, this.p).subscribe(
      {
        next: (res: any) => {
          if (res.code === 400) {
            this.errText =  res?.result?.error || res?.message;
            this.spinner.hide();
            setTimeout(() => {
              this.errorMessageSubmit = null;
            }, 3000);
          } else {
            this.dataviews = res.result;
            if (this.dataviews?.length > 0 && this.updatedDVs?.length > 0) {
            this.dataviews.forEach((ele: any) => {
              let index = this.updatedDVs?.findIndex((item: any) => item.viewId == ele.viewId)
              if (index > -1) {
                ele.type = this.updatedDVs[index]['type'];
              }
            })
          }
            this.totalViews = res.totalCount;
            this.spinner.hide();
            this.errorMessageSubmit = null;
          }
        },
        error: (err: any) => {
          this.spinner.hide();
          this.errText =  err?.result?.error || err;
          this.spinner.hide();
          setTimeout(() => {
            this.errorMessageSubmit = null;
          }, 3000);
          this.utilService.goToTop();
        }
  });

    this.getAllAccessGroups();
    this.initForm();
    this.getMergeViewsData();
  }
  getAllViews(){
     this.dataViewService.getAllViews('', this.sortByForView, this.sortType, this.pageSize, this.p).subscribe(
      {
        next: (res: any) => {
          if (res.code === 400) {
            this.errText =  res?.result?.error || res?.message;
            this.spinner.hide();
            setTimeout(() => {
              this.errorMessageSubmit = null;
            }, 3000);
          } else {
            this.dataviews = res.result;
            if (this.dataviews?.length > 0 && this.updatedDVs?.length > 0) {
            this.dataviews.forEach((ele: any) => {
              let index = this.updatedDVs?.findIndex((item: any) => item.viewId == ele.viewId)
              if (index > -1) {
                ele.type = this.updatedDVs[index]['type'];
              }
            })
          }
            this.totalViews = res.totalCount;
            this.spinner.hide();
            this.errorMessageSubmit = null;
          }
        },
        error: (err: any) => {
          this.spinner.hide();
          this.errText =  err?.result?.error || err;
          this.spinner.hide();
          setTimeout(() => {
            this.errorMessageSubmit = null;
          }, 3000);
          this.utilService.goToTop();
        }
  });
  }
  initForm() {
    this.accesGroupForm = this.fb.group({
      "userId": [sessionStorage.getItem('userId')],
      "action": ["Add"],
      "groupId": [null],
      "groupName": ["",[Validators.required, Validators.pattern('^[a-zA-Z0-9 ]*$')],[this.uniqueNameValidator()]],//^[a-zA-Z0-9]*$
      "assignedViews": this.fb.array([],[Validators.required])
    })
  }
  setCreatedDateValidation(){
     this.createdRange.setValidators((group: any) => {
      const start = group.get('startDate')?.value;
      const end = group.get('endDate')?.value;
      if (start && end) {
        if (end < start) {
          return { endBeforeStart: true };
        }
        const diff = (new Date(end).getTime() - new Date(start).getTime()) / (1000 * 60 * 60 * 24);
        if (diff > 62) {
          return { dateRangeInvalid: true };
        }
  }
    return null;
  });
  }
   setUpdatedDateValidation(){
     this.updatedRange.setValidators((group: any) => {
      const start = group.get('startDate')?.value;
      const end = group.get('endDate')?.value;
      if (start && end) {
        if (end < start) {
          return { endBeforeStart: true };
        }
        const diff = (new Date(end).getTime() - new Date(start).getTime()) / (1000 * 60 * 60 * 24);
        if (diff > 62) {
          return { dateRangeInvalid: true };
        }
  }
    return null;
  });
  }
  setListOfViews(item:any){
    this.listOfViews?.forEach((ele:any)=>{
      let index=item?.assignedViews?.findIndex((x:any)=>x?.id==ele?.viewId)
      if(index>-1){ele.isAssigned=true} 
    })
  }
  getListOfViews(item:any) {
    this.userId = sessionStorage.getItem('userId')
    let payload = { "userId": this.userId, "searchText": "", "sortBy": this.sortBy, "sortType": this.sortType };
    this.spinner.show();
    this.dataViewService.getListOfViews(payload)
      .subscribe({
        next: (res: any) => { if (res) { 
          this.listOfViews=res?.result?.map((item1:any)=>({viewId:item1?.viewId,viewName:item1?.viewName,isAssigned:false}));
          this.listOfAllViews=_.cloneDeep(this.listOfViews)          
          this.dataViewCount=this.listOfViews?.length || 0;
          if(item){
            this.setListOfViews(item)
          }
          this.setViewChips()
          
          this.spinner.hide(); 
        } }, error: (err: any) => {
          this.spinner.hide();
          this.errorMessageSubmit = err || err?.result?.error;
          this.spinner.hide();
          setTimeout(() => {
            this.errorMessageSubmit = null;
          }, 3000);
          this.utilService.goToTop();
        }
      })
  }
  getAllAccessGroups(flag = false) {
    this.userId = sessionStorage.getItem('userId')
    let payload = null
    payload = { "userId": this.userId, "searchText": this.searchText, "sortBy": '', "sortType": "" };
    if (flag) {
      payload = { "userId": this.userId, "searchText": this.searchText, "sortBy": 'access_group_name', "sortType": this.sortType };
    }

    this.dataViewService.getAllAccessGroups(payload, this.page, this.limit)
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.AGTableData = res?.result;
            this.totalViewsAG = res?.rowCount;
            this.spinner.hide(); this.errText = null
          }
        }, error: (err: any) => {
          this.spinner.hide();
          this.AGTableData = [];
          this.totalViewsAG = 0;
          this.errText = err || err?.result?.error;
        }
      })
  }
  getDate(date: any): Date {
    return new Date(date);
  }
  filterData(searchTerm: any) {
    this.p = 1;
    this.filterTableData(searchTerm, this.sortByForView, this.sortType, this.pageSize, this.p);
  }
  filterTableData(searchTerm: any, sortBy: any, sortType: any, pageSize: any, currentPage: any) {
    this.spinner.show();
    this.dataViewService.getAllViews(searchTerm, sortBy, sortType, pageSize, currentPage).subscribe(
      {
        next: (res: any) => {
          if (res.code === 400) {
            this.errText =  res.message;
            this.spinner.hide();
            this.dataviews = [];
            this.totalViews = 0;
            setTimeout(() => {
              this.errorMessageSubmit = null;
            }, 3000);
          } else {
            this.dataviews = res.result;
            if (this.dataviews?.length > 0 && this.updatedDVs?.length > 0) {
            this.dataviews.forEach((ele: any) => {
              let index = this.updatedDVs?.findIndex((item: any) => item.viewId == ele.viewId)
              if (index > -1) {
                ele.type = this.updatedDVs[index]['type'];
              }
            })
          }
            this.totalViews = res.totalCount;
            this.errorMessageSubmit = null;
            this.spinner.hide();
            this.utilService.goToTop();
          }
        },
        error: (err: any) => {
          this.spinner.hide();
          this.errText = err || err?.result?.error;
          this.dataviews = [];
          this.totalViews = 0;
          this.spinner.hide();
          setTimeout(() => {
            this.errorMessageSubmit = null;
          }, 3000);
          this.utilService.goToTop();
        },
      }
    );
  }
  getPage(event: any) {
    this.p = event;
    this.filterTableData(this.searchTerm, this.sortByForView, this.sortType, this.pageSize, this.p);
  }
  getPageAG(event: any) {
    this.page = event;
    this.getAllAccessGroups()
  }

  deleteAG() {
    this.showDeletepopup = !this.showDeletepopup
    this.viewNameToBeDeleted=null
  }

  deleteView() {
    this.showDeletepopup = false;    
    this.spinner.show();
    this.dataViewService.deleteView(this.viewIdToBeDeleted).subscribe(
      {
        next: (res: any) => {
          if (res.code === 400) {
            this.errorMessageSubmit = res.message;
            this.spinner.hide();
            setTimeout(() => {
              this.errorMessageSubmit = null;
            }, 3000);
          } else {
            const viewData = res;
            this.errorMessageSubmit = null;
            this.successMessage = `${viewData.result?.message}`;
            let filteredView = this.dataviews.filter(view => {
              return view.viewId != this.viewIdToBeDeleted;
            });

            this.dataviews = filteredView;
            this.spinner.hide();
            this.utilService.goToTop();
            setTimeout(() => {
              this.successMessage = null;
            }, 3000);
          }
          this.getAllViews();
        },
        error: (err: any) => {
          this.spinner.hide();
          this.errorMessageSubmit = err || err?.result?.error;
          this.spinner.hide();
          setTimeout(() => {
            this.errorMessageSubmit = null;
          }, 3000);
          this.utilService.goToTop();
        },
      }
    );
  }
  deleteViewAG() {
    this.showDeletepopup = false;    
    this.spinner.show();
    let payload = {
      "userId": sessionStorage.getItem('userId'),
      "accessGroupId": this.viewIdToBeDeletedAG
    }
    this.dataViewService.deleteAccessGroup(payload).subscribe(
      {
        next: (res: any) => {
          if (res.code === 400) {
            this.errorMessageSubmit = res.message;
            this.spinner.hide();
            setTimeout(() => {
              this.errorMessageSubmit = null;
            }, 3000);
          } else {
            const viewData = res;
            this.errorMessageSubmit = null;
            this.successMessage = `${viewData.result}`;

            this.getAllAccessGroups()
            this.spinner.hide();
            this.utilService.goToTop();
            setTimeout(() => {
              this.successMessage = null;
            }, 3000);
          }
        },
        error: (err: any) => {
          this.spinner.hide();
          this.errorMessageSubmit = err || err?.result?.error;
          this.spinner.hide();
          setTimeout(() => {
            this.errorMessageSubmit = null;
          }, 3000);
          this.utilService.goToTop();
        },
      }
    );
  }

  refreshView(){
    this.spinner.show();
    this.dataViewService.refreshView().subscribe({
      next: (res: any) =>{      
      this.successMessage = res?.message;
      this.spinner.hide();
      this.utilService.goToTop();
      this.p = 1; 
      this.filterTableData('', this.sortByForView, this.sortType, this.pageSize, this.p);
      setTimeout(() => {
        this.successMessage = null;
      }, 3000);
    },
    error: (err: any) =>{
      this.errorMessageSubmit = err || err?.result?.error;
      this.spinner.hide();
      setTimeout(() => {
        this.errorMessageSubmit = null;
      }, 3000);
    }
    });
  }

  deleteVD(viewId: any, viewName: any) {
    this.viewIdToBeDeleted = viewId;
    this.showDeletepopup = true;
    this.viewNameToBeDeleted = viewName;
  }
  showCreateAG() {
    this.showEditAGpopup = !this.showEditAGpopup
    this.createAG();
  }
  showEditAG() {
    this.showEditAGpopup = !this.showEditAGpopup;
    this.initForm();
    this.editAG();
    this.currentEditingItem=null;
    this.searchControl.reset()
  }
  editDV(id: number): void {
    this.router.navigate(['/edit-dataview', id]);
  }
  createAG() {
    this.headerText.set('Create Access Group');
  }
  editAG() {
    this.headerText.set('Edit Access Group');
  }
  toggleManageDV() {
    this.isManageDV = true;
    this.isManageAG = false;
  }
  toggleManageAG() {
    this.isManageDV = false;
    this.isManageAG = true;
  }
  showOtherGroups(index: any) {
    this.optionActiveId = index;
    this.otherListOptionFlag = !this.otherListOptionFlag
  }
  searchRecord() {
    this.getAllAccessGroups()
  }
  deleteVDAG(view: any) {
    this.viewIdToBeDeletedAG = view.groupId;
    // this.deleteItem=view.groupName
    this.viewNameToBeDeleted = view.groupName;
    this.showDeletepopup = true;
  }
  sortAg(i: any, headerName: any) {
    this.activeSortIndex = null;
    this.activeSortIndex = i;
    this.isAscending = !this.isAscending;
    this.page=1;
    if (this.isAscending) {
      this.sortType = 'asc'
    } else {
      this.sortType = 'desc'
    }
    this.getAllAccessGroups(true);
  }
  sortRefreshedCol(i: any, headerName: any) {
    this.activeSortIndex = null;
    this.activeSortIndex = i;
    this.isAscending = !this.isAscending;
    if(headerName == 'Created On'){
      this.sortBy = 'created';
    } if(headerName == 'Last Refreshed'){
      this.sortBy = 'last_refreshed';
    }if(headerName == 'Last Modified'){
      this.sortBy = 'updated';
    }
    if (this.isAscending) {
      this.sortType = 'asc'
    } else {
      this.sortType = 'desc'
    }
    this.filterMergeViewsData()
  }
  showPopupAG(action: any, item: any) { 
 
    this.getListOfViews(item);
    
    this.dataViewService.getAllAccessGroupNames({"userId":sessionStorage.getItem('userId'),"searchText":"","sortBy":"access_group_name","sortType":"desc"}).pipe(
      map((response:any) => response.result.map((item: any) => item.groupName))
    ).subscribe((groupNames) => {
      this.existingGroupNames = groupNames;
    });
    this.showEditAGpopup = true
    if (action == 'Add') {
      this.assignedView=[];  
      this.accesGroupForm.get('action').setValue(action)
      this.accesGroupForm.get('groupId').setValue(null)
      this.createAG()
    } else if (action == 'Edit') {
      this.currentEditingItem=item
      this.editAG()
      this.accesGroupForm.get('action').setValue(action)
      this.accesGroupForm.get('groupId').setValue(item.groupId)
      this.accesGroupForm.get('groupName').setValue(item.groupName)
      
      this.assignedView=item?.assignedViews || [];
      const newFormArray = this.fb.array(
        (item?.assignedViews || []).map((view:any) => this.fb.control(view)),
        [Validators.required]
      );
      
      this.accesGroupForm.setControl('assignedViews', newFormArray);
      this.accesGroupForm.markAllAsTouched();
      this.accesGroupForm.markAsDirty();
      
    }
  }
  sortDV(i: any) {
    this.activeSortIndex = null;
    this.activeSortIndex = i;
    this.isAscending = !this.isAscending;
    this.sortType = this.isAscending ? 'asc' : 'desc';
    this.p = 1;
    this.filterTableData(this.searchTerm, this.sortByForView, this.sortType, this.pageSize, this.p);
  }
  toggleOtherPopup(){
    this.showOthersPopup=!this.showOthersPopup}
  @HostListener('document:click', ['$event'])
  closeDropdown(event: MouseEvent) {
    const clickedInside = (event.target as HTMLElement).closest('.dropdown-container');
    if (!clickedInside) {
      this.showOthersPopup=false;
      this.otherListOptionFlag=false;
    }
  }
  @HostListener('document:click', ['$event'])
  closeShowMoreDropdown(event: MouseEvent) {
    const clickedInside = (event.target as HTMLElement).closest('.dropdown-container');
    if (!clickedInside) {
      this.otherListOptionFlag=false;
      this.showOthersPopup=false;
    }
  }
  unassignAll(){}
  onChangeDataview(dataview:any){
  }
  changeDataView(e: Event, dataview: any, index: any) {
    const checkbox = e.target as HTMLInputElement;
    let listOfAllViewsCopy = _.cloneDeep(this.listOfAllViews);
    let i: any = listOfAllViewsCopy.findIndex((ele: any) => ele.viewId == dataview.viewId)
    if (i > -1) listOfAllViewsCopy[i].isAssigned = checkbox.checked ? true : false;
    listOfAllViewsCopy.forEach((item: any) => {
      let index = this.assignedView?.findIndex((ele: any) => ele?.id == item?.viewId)
      if (index > -1) { item.isAssigned = true }
    })
    this.listOfViews[index]['isAssigned'] = checkbox.checked ? true : false;

    this.assignedView = _.cloneDeep(listOfAllViewsCopy?.filter((item: any) => item?.isAssigned == true)?.map((item: any) => ({ id: item.viewId, displayViewHeading: item.viewName, isAssigned: true })))
    let views = listOfAllViewsCopy?.filter((item: any) => item?.isAssigned == true)?.map((item: any) => ({ id: item.viewId, displayViewHeading: item.viewName, isAssigned: true }))
    this.assignedViews.clear()
    if (views?.length > 0) {
      views.forEach((item: any) => {
        this.assignedViews.push(this.fb.group({ id: [item?.id], displayViewHeading: [item?.displayViewHeading], isAssigned: [true] }))
      })
      if (!checkbox.checked) {
        let index = this.assignedView?.findIndex((ele: any) => ele?.id == dataview?.viewId)
        if (index > -1) { 
          this.assignedView=this.assignedView.filter((ele: any) => ele?.id != dataview?.viewId)
          let index=this.assignedViews.value.findIndex((item:any)=>item.id==dataview?.viewId)
          if(index>-1) this.assignedViews.removeAt(index)
        }
      }
    } else {
      this.assignedViews.clear()
      this.assignedView = []
    }

  }
  get assignedViews() {
    return this.accesGroupForm.get('assignedViews') as FormArray
  }
  setViewChips() {}


  unsetViewChip(viewId:any){
    let views = this.listOfViews?.filter((item: any) => item?.isAssigned == true)?.map((item: any) => ({ id: item.viewId, displayViewHeading: item.viewName, isAssigned: true }))
    if(views?.length>0){
      let index=this.assignedViews.value.findIndex((item:any)=>item.id==viewId)
      if(index>-1) {
        this.assignedViews.removeAt(index)
      }
      this.assignedView = _.cloneDeep(views)
    }else{
      this.assignedViews.clear()
      this.assignedView = []
    }
  }
  uncheckView(viewId: any) {
    this.assignedView=this.assignedView.filter((item:any)=>item?.id!= viewId)
    let index=this.assignedViews.value.findIndex((item:any)=>item.id==viewId)
    if(index>-1) this.assignedViews.removeAt(index) 
    let i = this.listOfViews.findIndex((item: any) => item.viewId == viewId);
    if (i > -1) {this.listOfViews[i].isAssigned = false}
  }
  removeAllSelectedViews() {
    this.listOfViews.forEach((item: any) => {item.isAssigned = false;})
    this.assignedViews.clear()
    this.assignedView = []
  }
  saveUserGroup() {

    if (this.accesGroupForm.get('action').value == 'Add') {
      let payload = this.accesGroupForm.value
      this.addUpdateUserGroup(payload)
    } else if (this.accesGroupForm.get('action').value == 'Edit') {
      let payload = this.accesGroupForm.value
      this.addUpdateUserGroup(payload)
    }
  }
  addUpdateUserGroup(payload: any) {
    this.spinner.show();
    this.dataViewService.addUpdateAccessGroup(payload)
      .subscribe(
        {
          next: (res: any) => {
            this.showEditAG()
            this.errorMessageSubmit = null;
            this.successMessage = res?.result;
            setTimeout(() => {
              this.successMessage = null;
            }, 3000);
            this.getAllAccessGroups()
            this.spinner.hide();
          },
          error: (err: any) => {
            this.spinner.hide();
            this.errorMessageSubmit = err || err?.result?.error;
            this.spinner.hide();
            setTimeout(() => {
              this.errorMessageSubmit = null;
            }, 3000);
            this.utilService.goToTop();
          }
        }
      )
  }
  capitalizeTextOnKeyup() {
    const nameControl = this.accesGroupForm.get('groupName');
    if (nameControl) {
      const value = nameControl.value || '';
      const inputElement = document.querySelector('input[formControlName="groupName"]') as HTMLInputElement;
      const selectionStart = inputElement ? inputElement.selectionStart : null;
      const selectionEnd = inputElement ? inputElement.selectionEnd : null;
      const capitalizedValue = value.toUpperCase();
      if (capitalizedValue !== value) {
        nameControl.setValue(capitalizedValue, { emitEvent: false });
        if (inputElement && selectionStart !== null && selectionEnd !== null) {
          inputElement.setSelectionRange(selectionStart, selectionEnd);
        }
      }
    }
  }
  get groupName() {
    return this.accesGroupForm.get('groupName') as FormControl;
  }
  uniqueNameValidator() {
    return (control: any) => {
      return new Promise(resolve => {
        setTimeout(() => {
          if(this.accesGroupForm.get('action').value=='Edit' && control?.value?.toLowerCase()==this.currentEditingItem?.['groupName']?.toLowerCase()){
            resolve(null); 
          }
          const isNameTaken = this.existingGroupNames.some((item:any) => item?.toLowerCase() === control?.value?.toLowerCase());
          if (isNameTaken) {
            resolve({ uniqueName: true }); 
          } else {
            resolve(null); 
          }
        }, 500);
      });
    };
  }
  filterViews(event: any) {
    let searchTxt = event.target.value
    if (searchTxt != "") {
      if (this.currentEditingItem != null) {
        let listOfAllViewsCopy = _.cloneDeep(this.listOfAllViews)
        listOfAllViewsCopy.forEach((item: any) => {
          let index = this.assignedView.findIndex((x: any) => x.id == item.viewId)
          if (index > -1) {
            item.isAssigned = true;
          }
        })
        this.listOfViews = listOfAllViewsCopy?.filter((item: any) => item.viewName?.toLowerCase()?.includes(searchTxt.toLowerCase()))
      } else {
        let listOfAllViewsCopy = _.cloneDeep(this.listOfAllViews)
        listOfAllViewsCopy.forEach((item: any) => {
          let index = this.assignedView.findIndex((x: any) => x.id == item.viewId)
          if (index > -1) {
            item.isAssigned = true;
          }
        })
        this.listOfViews = listOfAllViewsCopy?.filter((item: any) => item.viewName?.toLowerCase()?.includes(searchTxt.toLowerCase()))
      }
    } else {
      if (this.currentEditingItem != null) {
        let listOfAllViewsCopy=_.cloneDeep(this.listOfAllViews)
        listOfAllViewsCopy.forEach((item:any)=>{
          let index=this.assignedView.findIndex((x:any)=>x.id==item.viewId)
          if(index>-1){
            item.isAssigned=true;
          }
        })
        this.listOfViews = _.cloneDeep(listOfAllViewsCopy)
      } else {
        let listOfAllViewsCopy=_.cloneDeep(this.listOfAllViews)
        listOfAllViewsCopy.forEach((item:any)=>{
          let index=this.assignedView.findIndex((x:any)=>x.id==item.viewId)
          if(index>-1){
            item.isAssigned=true;
          }
        })
        this.listOfViews = _.cloneDeep(listOfAllViewsCopy)
      }
    }
    
  }
  cancelForm(){
    this.showConfirmPopup=true;
  }
  closeConfimPopup(){
    this.showConfirmPopup=false
  }
  resetForm() {
    if (this.accesGroupForm.get('action').value == 'Add') {
      this.accesGroupForm.get('groupName').setValue('');
      this.accesGroupForm.get('assignedViews').reset()
      this.assignedView = []
      this.listOfViews = _.cloneDeep(this.listOfAllViews)
      this.showConfirmPopup = false
      this.cancelFlag = false
    } else if (this.accesGroupForm.get('action').value == 'Edit') {
      this.accesGroupForm.get('groupName').setValue(this.currentEditingItem.groupName)
      this.assignedView=_.cloneDeep(this.currentEditingItem?.assignedViews)
      this.assignedView?.forEach((item:any)=>{
        this.assignedViews.push(this.fb.group({ id: [item?.id], displayViewHeading: [item?.displayViewHeading], isAssigned: [true]}))
      })
      this.listOfViews?.forEach((ele: any) => {
        let index = this.assignedView?.findIndex((x: any) => x?.id == ele?.viewId)
        if (index > -1) { ele.isAssigned = true }else{
          ele.isAssigned = false
        }
      })

      this.showConfirmPopup = false
      this.cancelFlag = false
      this.accesGroupForm.value.assignedViews=[]
      this.accesGroupForm.value.assignedViews=_.cloneDeep(this.assignedView)
      console.log(this.accesGroupForm.value)
    }
  }
  checkAssignedView() {
    if (this.assignedView?.length > 0) {
      this.accesGroupForm.markAsDirty();
      return false
    } else {
      return !this.accesGroupForm.dirty
    }
  }
  clearSearch() {
    this.searchText = ''; 
    this.getAllAccessGroups()
  }

  clearSearchForView() {
    this.searchTerm = '';
    this.p = 1; 
    this.filterTableData(this.searchTerm, this.sortByForView, this.sortType, this.pageSize, this.p);
  }

  goToHomePage(){
    this.router.navigate(['/home']);
  }

  isSaveEnabled(): boolean {
    return this.accesGroupForm.get('groupName').valid && (this.assignedView?.length>0);
  }

   showRefreshDV() {
    this.showRefreshpopup = !this.showRefreshpopup;
  }

    SelectDVs(view: any, event: any) {
      if (event.target.checked) {
       if (!this.updatedDVs.some((dv: any) => dv.viewId === view.viewId && dv.isSelected)) {
          view.isSelected = true;
        }
      } else {
         view.isSelected = false;
      }
      this.selectedDataviews = this.updatedDVs.filter((dv: any) => dv.isSelected === true);
    }
  
  
  SelectAllUpDVs() {
    // const topValidDVs = this.updatedDVs
    //   .filter((dv: any) => dv.type !== 'DELETED')
    //   .slice(0, 20);
    const topValidDVs = this.updatedDVs.slice(0, 20);;
    const allSelected = topValidDVs.every((dv: any) => dv.isSelected);

    this.updatedDVs.forEach((dv: any) => {
      if (topValidDVs.includes(dv)) {
        dv.isSelected = !allSelected;
      }
    });
    this.selectedDataviews = topValidDVs.filter((dv: any) => dv.isSelected);
  }
  
  get SelectAllUpdatedDVs(): boolean {
  //  const validDVs = this.updatedDVs.filter((dv: any) => dv.type !== 'DELETED');
    const validDVs = this.updatedDVs
    const topDVs = validDVs.slice(0, 20);
    return topDVs.length > 0 && topDVs.every((dv: any) => dv.isSelected);
  }
  refreshVDAG(view: any[]){
    this.selectedDataviews = [view];
    let payload = this.getRefreshMetaDataPayload();
     this.spinner.show();
    this.dataViewService.refreshDataView(payload)
        .subscribe({
          next: (res: any) => {
            if (res) {
              this.successMessage = res?.message;
              this.utilService.goToTop();
              this.spinner.hide(); this.errText = null;
              setTimeout(() => {
                this.successMessage = null;
              }, 3000);
            }
            this.getAllViews();
           }, error: (err: any) => {
            this.spinner.hide();
            this.errorMessageSubmit = err || err?.result?.error;
            setTimeout(() => {
                this.errorMessageSubmit = null;
              }, 3000);
          }
   })
  }

  getMergeViewsData(){
    let payload: {
      userId: string | null,
      dateType: string | null,
      startDate: string | null,
      endDate: string | null,
      sortBy: string,
      sortType: string
    } = {
      userId: this.userId,
      dateType: null,
      startDate: null,
      endDate: null,
      sortBy: 'created',
      sortType: this.sortType
    }
    
  this.dataViewService.getMergeViewsData(payload)
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.spinner.hide(); this.errText = null;
            this.totalRefreshViews = res?.rowCount || 0;
            this.updatedDVs = (res?.result || []).map((dv: any) => ({
              ...dv,
              isSelected: false
            }));
          }
          if (this.dataviews?.length > 0 && this.updatedDVs?.length > 0) {
            this.dataviews.forEach((ele: any) => {
              let index = this.updatedDVs?.findIndex((item: any) => item.viewId == ele.viewId)
              if (index > -1) {
                ele.type = this.updatedDVs[index]['type'];
              }
            })
          }
        }, error: (err: any) => {
          this.spinner.hide();
          this.errorMessageSubmit = err || err?.result?.error;
           setTimeout(() => {
          this.errorMessageSubmit = null;
        }, 3000);
        this.utilService.goToTop();
        }
      })
  }
  startDate: Date | null = null;
  endDate: Date | null = null;

 
onDateSelected(dateType:any,event:any) {
  this.startDate = null;this.endDate = null;
  this.dateType = dateType;
  let startDate = this.createdRange.get('startDate')?.value;
  let endDate = this.createdRange.get('endDate')?.value;
  if (dateType === 'updated') {
    this.createdRange.reset();
    startDate=this.updatedRange.get('startDate')?.value;
    endDate=this.updatedRange.get('endDate')?.value;
  }else{
    this.updatedRange.reset();
    startDate = this.createdRange.get('startDate')?.value;
    endDate = this.createdRange.get('endDate')?.value;
  }
  
  if ((startDate && endDate) && (this.createdRange.valid && this.updatedRange.valid)) {
    this.startDate = startDate;
    this.endDate = endDate;
     this.filterMergeViewsData();
  }
}
  getRefreshMetaDataPayload(){
    const payload = {
      userId: this.userId,
      viewDtoList: (this.selectedDataviews || []).map((dv: any) => ({
      viewId: dv.viewId,
      viewName: dv.actualViewName?dv.actualViewName:dv.viewName,
      viewType: dv.type
      }))
    };
    return payload;
}

  bulkRefreshVDAGData(){
   let payload = this.getRefreshMetaDataPayload();
   this.spinner.show()
    this.dataViewService.refreshDataView(payload)
        .subscribe({
          next: (res: any) => {
            if (res) {
              this.successMessage = res?.message;
              this.utilService.goToTop();
              this.spinner.hide(); this.errText = null;
              setTimeout(() => {
                this.successMessage = null;
              }, 3000);
              this.getAllViews();
              this.showRefreshDV();
              this.getMergeViewsData();
              this.resetRefreshPopup();
            }
          }, error: (err: any) => {
            this.errorMessageSubmit =  err;
            this.spinner.hide(); 
            setTimeout(() => {
            this.errorMessageSubmit = null;
            }, 3000);
            this.utilService.goToTop();
          }
   })
  }

  resetRefreshPopup() {
    this.selectedDataviews = [];
    this.updatedDVs.forEach((dv: any) => {
      dv.isSelected = false;
    });
    this.selectAllUpdatedDVs = false;
    this.startDate = null;
    this.endDate = null;
    this.dateType = null;
    this.createdRange.reset();
    this.updatedRange.reset();
    this.sortBy = 'created';
    this.sortType = 'desc';
    this.isAscending = false;
    this.activeSortIndex = null;
    this.filterMergeViewsData();
  }
cancelRefresh(){
  if (
      this.startDate !== null ||
      this.endDate !== null ||
      this.dateType !== null ||
      this.sortBy !== 'created' ||
      this.sortType !== 'desc' ||
      this.selectedDataviews.length > 0
      ) {
          this.resetRefreshPopup();
        }
}
  filterMergeViewsData(){
    let payload: {
      userId: string | null,
      dateType: string | null,
      startDate: any | null,
      endDate: any | null,
      sortBy: string,
      sortType: string
    } = {
      userId: this.userId,
      dateType: this.dateType,
      startDate: this.startDate? formatDate(this.startDate, 'yyyy-MM-dd', 'en-US') : null,
      endDate: this.endDate? formatDate(this.endDate, 'yyyy-MM-dd', 'en-US') : null,
      sortBy: this.sortBy,
      sortType: this.sortType
    }
  this.spinner.show();
  this.dataViewService.getMergeViewsData(payload)
      .subscribe({
        next: (res: any) => {
          if (res.code == 200) {
            this.spinner.hide(); this.errText = null;
            this.totalRefreshViews = res?.rowCount || 0;
          
            this.updatedDVs = (res?.result || []).map((dv: any) => ({
              ...dv,
              isSelected: false
            }));
          this.selectAllUpdatedDVs = false;
          this.selectedDataviews = [];
          }
          }, error: (err: any) => {
          this.spinner.hide();
          this.updatedDVs = [];
          this.selectedDataviews = [];
        }
      })
  }
  getCreatedEndDateMax(): Date {
  const start = this.createdRange.get('startDate')?.value;
  if (start) {
    const plus62 = new Date(start);
    plus62.setDate(plus62.getDate() + 62);
    return plus62 < this.maxDate ? plus62 : this.maxDate;
  }
  return this.maxDate;
}
formatApiDate(isoString: string): string {
  const date = isoString.substring(0, 10); // "2025-02-25"
  const time = isoString.substring(11, 16); // "07:07"
  
  const [year, month, day] = date.split("-");
  return `${day}/${month}/${year} ${time}`; // "25/02/2025 07:07"
}
}
